var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5105_4051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.04875 12.346L6.58209 2.87305C7.28496 3.28684 10.8292 5.24833 11.4016 5.62132L5.86829 15.0949C5.26312 15.8943 0.282084 13.5593 1.04875 12.3455V12.346Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9475 12.3452L11.4142 2.87276C10.6406 1.5854 8.97455 1.11758 7.60616 1.87793C6.23777 2.63827 5.8211 4.2762 6.59467 5.62103L12.128 15.0946C12.9016 16.3814 14.5677 16.8492 15.936 16.0889C17.2447 15.3285 17.7211 13.6325 16.9475 12.3463V12.3452Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4436 16.4544C4.97762 16.4544 6.22119 15.2417 6.22119 13.7457C6.22119 12.2498 4.97762 11.0371 3.4436 11.0371C1.90958 11.0371 0.666016 12.2498 0.666016 13.7457C0.666016 15.2417 1.90958 16.4544 3.4436 16.4544Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5105_4051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 16.6667,
    fill: "white",
    transform: "translate(0.666016 0.666016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.d89727a616c9eb0b3f4c9baf6f322df4.svg";
export { ForwardRef as ReactComponent };